/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Fallback_Overage_Not_AllowedInputs */



/**
* | output |
* | --- |
* | "Token pool depleted. This response used oneAI Standard (free)." |
*
* @param {Chat_Fallback_Overage_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_fallback_overage_not_allowed = /** @type {((inputs?: Chat_Fallback_Overage_Not_AllowedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Fallback_Overage_Not_AllowedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Token-Pool aufgebraucht. Diese Antwort verwendete oneAI Standard (kostenlos).")
	return /** @type {LocalizedString} */ ("Token pool depleted. This response used oneAI Standard (free).")
});